import React, { FC } from 'react'

import { FiltersSharedProps } from './Filters.types'
import { InputBasedFilter } from './FiltersVariations/Input'

interface MinPetsFilterProps extends FiltersSharedProps {
  initialValue?: string
  onChange: (value?: string) => void
}

export const MinPetsFilter: FC<MinPetsFilterProps> = props => (
  <InputBasedFilter title="Min. Pets" type="number" placeholder="0" {...props} />
)
